<!--
 * @Author: 张天昊
 * @Date: 2024-05-29 11:33:32
 * @LastEditTime: 2024-06-07 10:27:01
 * @LastEditors: 张天昊
 * @Description: 隐私信息查看按钮
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/PrivacyCheckButton.vue
-->
<script>
import { computed, defineComponent, ref } from 'vue';
import { Dialog } from 'vant';
import router from '@/router/routers';
import { httpCheckUserPrivate } from '@/service';
import store from '@/store';

export default defineComponent({
  setup() {
    const checked = computed(
      () => store.state.itineraryUniversal.privacyChecked
    );
    const isEncrypt = ref(true);

    function onClick() {
      // 能查看之后就一直可以查看
      if (!checked.value) {
        privacyCheck();
      }
      // if (checked) {
      //   toggleEncrypt(!isEncrypt.value);
      // } else {
      //   privacyCheck();
      // }
    }
    async function privacyCheck() {
      const detailInfoValue = store.state.itineraryUniversal.detailInfo.value
      const id = detailInfoValue ? detailInfoValue.itineraryInfoMessage.teamId : router.currentRoute.params.id;
      const res = await httpCheckUserPrivate(id);
      if (res && res.ret === 0 && res.data && res.data.needApply) {
        Dialog.confirm({
          title: '',
          confirmButtonColor: '#00982d',
          message:
            '您还未进行敏感数据查看申请或申请还未审批通过，请在完成申请并审批通过之后再来查看游客敏感数据',
          confirmButtonText: '去申请',
          cancelButtonText: '取消'
        })
          .then(() => {
            // on confirm
            // this.$router.push({
            //   name: 'PrivateInfoApply',
            //   params: { teamId: this.code }
            // });
            // 打开团队监管App对应地址
            window.yyn.invokeJSB('openWindow', {
              openUrl: `${window.location.origin}/team-supervision/supervision-app/#/cockpit_app/PrivateInfoApply/${id}`,
              isFullScreen: 1,
              // team-supervision-app这个工程内部的navbar，即使全屏也是使用的原生头的返回键（而不是van-nav-bar h5自己的返回）
              // 为了不牵扯更多页面的回归测试，这里就保持沿用原生头
              // hiddenTitleBar: true,
              needLoading: 1
            });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        // 替换游客数据
        store.dispatch(
          'itineraryUniversal/updateTouristsIntoView',
          res.data.itineraryTouristMessage
        );
        store.commit('itineraryUniversal/setPrivacyChecked', true);
        toggleEncrypt(false);
      }
    }
    function toggleEncrypt(value) {
      isEncrypt.value = value;
    }

    return {
      isEncrypt,
      onClick
    };
  }
});
</script>

<template>
  <van-button
    color="#36B374"
    size="small"
    class="flex-shrink-0 custom-button"
    @click="onClick"
  >
    <template #icon>
      <svg-icon
        pre-path="itineraryUniversal"
        class="w-20 h-16"
        :name="isEncrypt ? 'ic-eye-open' : 'ic-eye-close'" /></template
    >敏感数据查看</van-button
  >
</template>
